export default "__VITE_ASSET__48a85558__"